export interface IIconInputProps {
  className?: string;
  // onclick?: (e: React.MouseEvent<HTMLOrSVGElement>) => void;
  // target?: string;
}

export const SidebarHome = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="w-6 h-6"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"
      />
    </svg>
  );
};

export const User = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="w-6 h-6"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z"
      />
    </svg>
  );
};

export const Post = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className="fill-primary"
    >
      <path d="M2 16V2H9V9H16V10C16.7 10 17.37 10.13 18 10.35V6L12 0H2C0.89 0 0 0.89 0 2V16C0 16.5304 0.210714 17.0391 0.585786 17.4142C0.960859 17.7893 1.46957 18 2 18H10.35C10.13 17.37 10 16.7 10 16H2ZM11 1.5L16.5 7H11V1.5ZM20 15V17H17V20H15V17H12V15H15V12H17V15H20Z" />
    </svg>
  );
};

export const EditIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="w-3 h-3"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L6.832 19.82a4.5 4.5 0 01-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 011.13-1.897L16.863 4.487zm0 0L19.5 7.125"
      />
    </svg>
  );
};

export const DeletePic = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="w-4 h-4 stroke-delete"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
      />
    </svg>
  );
};

export const ArrowDownIcon = ({ className }: IIconInputProps) => {
  return (
    <svg
      className={`stroke-current ${className ?? ""}`}
      width="11"
      height="7"
      viewBox="0 0 11 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.59766 1.22461L5.59766 5.22461L9.59766 1.22461"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CMSIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M12 8.25C11.2583 8.25 10.5333 8.46993 9.91661 8.88199C9.29993 9.29404 8.81928 9.87971 8.53545 10.5649C8.25162 11.2502 8.17736 12.0042 8.32205 12.7316C8.46675 13.459 8.8239 14.1272 9.34835 14.6517C9.87279 15.1761 10.541 15.5333 11.2684 15.6779C11.9958 15.8226 12.7498 15.7484 13.4351 15.4645C14.1203 15.1807 14.706 14.7001 15.118 14.0834C15.5301 13.4667 15.75 12.7417 15.75 12C15.747 11.0064 15.351 10.0542 14.6484 9.35163C13.9458 8.64901 12.9936 8.25297 12 8.25ZM20.0962 12C20.0943 12.3504 20.0686 12.7003 20.0194 13.0472L22.3017 14.8341C22.4011 14.9161 22.4681 15.0309 22.4907 15.1578C22.5133 15.2847 22.49 15.4155 22.425 15.5269L20.2659 19.2544C20.2003 19.3647 20.0979 19.4484 19.9766 19.4907C19.8554 19.5329 19.7231 19.5311 19.6031 19.4855L16.9195 18.4073C16.3607 18.8377 15.7492 19.1948 15.0998 19.47L14.6986 22.3191C14.6761 22.4467 14.6101 22.5625 14.5116 22.6468C14.4132 22.7311 14.2886 22.7786 14.1591 22.7812H9.84094C9.71374 22.7788 9.59114 22.7333 9.49315 22.6521C9.39516 22.571 9.32757 22.459 9.3014 22.3345L8.90015 19.4855C8.249 19.2134 7.63704 18.8557 7.08047 18.4219L4.39687 19.5C4.27691 19.5457 4.1447 19.5476 4.02347 19.5054C3.90224 19.4632 3.79977 19.3796 3.73406 19.2694L1.575 15.5423C1.51001 15.431 1.48673 15.3002 1.50931 15.1733C1.5319 15.0464 1.59887 14.9316 1.69828 14.8495L3.98062 13.0627C3.93194 12.7105 3.90626 12.3555 3.90375 12C3.9057 11.6496 3.93138 11.2997 3.98062 10.9528L1.69828 9.16594C1.59887 9.08386 1.5319 8.96911 1.50931 8.84219C1.48673 8.71527 1.51001 8.58446 1.575 8.47312L3.73406 4.74563C3.79969 4.63528 3.90214 4.55161 4.02337 4.50934C4.14461 4.46707 4.27686 4.46891 4.39687 4.51453L7.08047 5.59266C7.63927 5.16235 8.25079 4.80524 8.90015 4.53L9.3014 1.68094C9.32386 1.55332 9.38994 1.43746 9.48835 1.35316C9.58675 1.26886 9.71138 1.22135 9.84094 1.21875H14.1591C14.2863 1.22123 14.4089 1.26675 14.5068 1.34788C14.6048 1.42901 14.6724 1.54097 14.6986 1.66547L15.0998 4.51453C15.7518 4.78639 16.3646 5.14408 16.9219 5.57812L19.6031 4.5C19.7231 4.45434 19.8553 4.45243 19.9765 4.49461C20.0978 4.53679 20.2002 4.62036 20.2659 4.73062L22.425 8.45813C22.49 8.56946 22.5133 8.70027 22.4907 8.82719C22.4681 8.95411 22.4011 9.06886 22.3017 9.15094L20.0194 10.9378C20.068 11.2898 20.0937 11.6446 20.0962 12Z" fill="#2A9D8F"/>
    <circle cx="12" cy="12" r="6" fill="white"/>
    <path d="M15.4048 10.75H15.703L15.6509 10.4564C15.5733 10.0185 15.4309 9.6232 15.2208 9.27385C15.013 8.92573 14.7534 8.62895 14.4421 8.38551C14.1322 8.14047 13.7846 7.955 13.401 7.82898C13.0196 7.7028 12.6141 7.64062 12.186 7.64062C11.461 7.64062 10.8074 7.81836 10.2328 8.17886C9.65889 8.53899 9.21103 9.04954 8.88783 9.70146C8.56255 10.3576 8.40479 11.1264 8.40479 12C8.40479 12.8736 8.56255 13.6424 8.88783 14.2985C9.21103 14.9505 9.65889 15.461 10.2328 15.8211C10.8074 16.1816 11.461 16.3594 12.186 16.3594C12.614 16.3594 13.0194 16.2972 13.4008 16.1711C13.7841 16.0452 14.1316 15.8612 14.4416 15.6188L14.4416 15.6188L14.4427 15.618C14.7537 15.372 15.0132 15.074 15.221 14.7258C15.4308 14.3743 15.5732 13.9794 15.6509 13.5439L15.7033 13.25H15.4048H14.436H14.2326L14.1913 13.4492C14.1399 13.6967 14.0512 13.9109 13.9276 14.0951L13.9272 14.0957C13.8031 14.2819 13.6523 14.4383 13.4741 14.5663C13.2969 14.6928 13.0995 14.7889 12.8803 14.8542C12.6596 14.9199 12.4285 14.9531 12.186 14.9531C11.7462 14.9531 11.3536 14.8427 11.002 14.6238C10.657 14.4075 10.3754 14.0855 10.1611 13.645C9.95257 13.2112 9.84229 12.6661 9.84229 12C9.84229 11.3339 9.95257 10.7888 10.1611 10.3549C10.3754 9.91444 10.6571 9.5924 11.0021 9.37611C11.3537 9.15728 11.7463 9.04688 12.186 9.04688C12.4285 9.04688 12.6596 9.0801 12.8803 9.14585C13.0988 9.21092 13.2957 9.3079 13.4726 9.43656L13.4726 9.43658L13.4756 9.43869C13.653 9.56381 13.8034 9.71847 13.9272 9.9043L13.9272 9.90431L13.9284 9.90606C14.0511 10.0868 14.1397 10.3002 14.1912 10.5503L14.2322 10.75H14.436H15.4048Z" fill="#2A9D8F" stroke="#2A9D8F" strokeWidth="0.5"/>
    </svg>
  );
};

export const ChatIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 6.5C14.335 6.5 6.50002 14.335 6.50002 24C6.50002 27.188 7.35102 30.173 8.83802 32.745C9.00802 33.038 9.05102 33.387 8.95802 33.713L6.84202 41.155L14.282 39.039C14.4432 38.9931 14.6119 38.9801 14.7782 39.0007C14.9445 39.0213 15.105 39.0751 15.25 39.159C17.9091 40.6975 20.9279 41.5051 24 41.5C33.665 41.5 41.5 33.665 41.5 24C41.5 14.335 33.665 6.5 24 6.5ZM4.00002 24C4.00002 12.954 12.954 4 24 4C35.046 4 44 12.954 44 24C44 35.046 35.046 44 24 44C20.6702 44.0048 17.3923 43.1749 14.466 41.586L6.23102 43.928C4.91202 44.303 3.69402 43.084 4.06902 41.766L6.41102 33.528C4.82405 30.6033 3.99515 27.3275 4.00002 24ZM16 20.25C16 19.56 16.56 19 17.25 19H30.75C30.9142 19 31.0767 19.0323 31.2284 19.0951C31.38 19.158 31.5178 19.25 31.6339 19.3661C31.75 19.4822 31.8421 19.62 31.9049 19.7716C31.9677 19.9233 32 20.0858 32 20.25C32 20.4142 31.9677 20.5767 31.9049 20.7284C31.8421 20.88 31.75 21.0178 31.6339 21.1339C31.5178 21.25 31.38 21.342 31.2284 21.4049C31.0767 21.4677 30.9142 21.5 30.75 21.5H17.25C16.56 21.5 16 20.94 16 20.25ZM17.25 26.5C16.9185 26.5 16.6006 26.6317 16.3661 26.8661C16.1317 27.1005 16 27.4185 16 27.75C16 28.0815 16.1317 28.3995 16.3661 28.6339C16.6006 28.8683 16.9185 29 17.25 29H26.75C27.0815 29 27.3995 28.8683 27.6339 28.6339C27.8683 28.3995 28 28.0815 28 27.75C28 27.4185 27.8683 27.1005 27.6339 26.8661C27.3995 26.6317 27.0815 26.5 26.75 26.5H17.25Z"
        fill="#2A9D8F"
      />
    </svg>
  );
};

export const BusinessIcon2 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M4.615 20C4.155 20 3.771 19.846 3.463 19.538C3.15433 19.2293 3 18.845 3 18.385V8.615C3 8.155 3.15433 7.771 3.463 7.463C3.771 7.15433 4.155 7 4.615 7H9V5.615C9 5.155 9.15433 4.771 9.463 4.463C9.771 4.15433 10.1547 4 10.614 4H13.384C13.844 4 14.2283 4.15433 14.537 4.463C14.845 4.771 14.999 5.155 14.999 5.615V7H19.384C19.844 7 20.228 7.15433 20.536 7.463C20.8447 7.771 20.999 8.155 20.999 8.615V18.385C20.999 18.845 20.845 19.229 20.537 19.537C20.2283 19.8457 19.844 20 19.384 20H4.615ZM10 7H14V5.615C14 5.46167 13.936 5.32067 13.808 5.192C13.6793 5.064 13.5383 5 13.385 5H10.615C10.4617 5 10.3207 5.064 10.192 5.192C10.064 5.32067 10 5.46167 10 5.615V7ZM20 14.5H14V16H10V14.5H4V18.385C4 18.5383 4.064 18.6793 4.192 18.808C4.32067 18.936 4.46167 19 4.615 19H19.385C19.5383 19 19.6793 18.936 19.808 18.808C19.936 18.6793 20 18.5383 20 18.385V14.5ZM11 15H13V13H11V15ZM4 13.5H10V12H14V13.5H20V8.615C20 8.46167 19.936 8.32067 19.808 8.192C19.6793 8.064 19.5383 8 19.385 8H4.615C4.46167 8 4.32067 8.064 4.192 8.192C4.064 8.32067 4 8.46167 4 8.615V13.5Z"
        fill="#2A9D8F"
      />
    </svg>
  );
};

export const AgreementIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="24" viewBox="0 0 20 24" fill="none">
<path d="M17 2H3C2.44772 2 2 2.44772 2 3V21C2 21.5523 2.44772 22 3 22H17C17.5523 22 18 21.5523 18 21V3C18 2.44772 17.5523 2 17 2Z" stroke="#2A9D8F" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M6 2H10.5V10L8.25 8L6 10V2Z" stroke="#2A9D8F" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M6 14H11M6 17H14" stroke="#2A9D8F" strokeWidth="2.25" strokeLinecap="round"/>
</svg>
  );
};

export const BusinessIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M7.86379 7.18717V5.29972C7.86379 4.42458 8.21144 3.58528 8.83026 2.96647C9.44908 2.34765 10.2884 2 11.1635 2H12.8464C13.7215 2 14.5608 2.34765 15.1796 2.96647C15.7985 3.58528 16.1461 4.42458 16.1461 5.29972V7.18717M6.29972 7.18717H17.7003C17.7003 7.18717 21 7.18717 21 10.4869V18.591C21 18.591 21 21.8907 17.7003 21.8907H6.29972C6.29972 21.8907 3 21.8907 3 18.591V10.4869C3 10.4869 3 7.18717 6.29972 7.18717Z" stroke="#2A9D8F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <line x1="3" y1="12.25" x2="21" y2="12.25" stroke="#2A9D8F" strokeWidth="1.5"/>
    <rect x="9" y="13" width="6" height="3" fill="#2A9D8F"/>
    </svg>
  );
};


export const PaySlip = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="23" viewBox="0 0 24 23" fill="none">
<path d="M12.796 13.3333V12.4116C13.9472 12.1694 14.8062 11.4135 14.8062 10.1973C14.8062 9.51766 14.6519 8.97168 14.2607 8.59106C13.9517 8.28206 13.4779 8.07617 12.8188 7.98315L11.9329 7.85978C11.6755 7.82886 11.5212 7.73617 11.4285 7.64355C11.3153 7.53027 11.2843 7.39608 11.2843 7.30347C11.2843 6.98446 11.5417 6.62386 12.1698 6.62386C12.4893 6.62386 13.0968 6.59277 13.5601 7.05648L14.693 5.92367C14.1867 5.41732 13.5653 5.16715 12.796 5.08577V4H11.204V5.19645C10.1552 5.51367 9.54395 6.32829 9.54395 7.36556C9.54395 7.99357 9.70874 8.48787 10.0487 8.83805C10.3783 9.17798 10.8722 9.39437 11.5212 9.48706L12.4067 9.61027C12.6436 9.64136 12.7983 9.71338 12.891 9.80607C12.9937 9.91935 13.0352 10.0636 13.0352 10.2389C13.0352 10.661 12.6951 10.8978 11.9845 10.8978C11.3975 10.8978 10.7284 10.7637 10.3472 10.3831L9.19385 11.536C9.75741 12.1156 10.4241 12.3715 11.204 12.4618V13.3333H12.796Z" fill="#2A9D8F"/>
<path d="M18.6667 4.44442V0H5.33333V4.44442L0 8V22.6667H24V8L18.6667 4.44442ZM6.66667 1.33333H17.3333V12.4444L12 16L6.66667 12.4444V1.33333ZM1.33333 8.71354L5.33333 6.04687V11.5556L1.33333 8.88892V8.71354ZM22.6667 21.3333H1.33333V10.4914L12 17.6025L22.6667 10.4914V21.3333ZM22.6667 8.88892L18.6667 11.5556V6.04687L22.6667 8.71354V8.88892Z" fill="#2A9D8F"/>
</svg>
  );
};
